import { get4CornersOfHouse } from "./get4CornersOfHouse";
import { isInsideCircle } from "./isInside";

export function isHouseCovered(house: THouseDef, circles: TBubbleState[]): boolean {
	const corners = get4CornersOfHouse(house);
	const openCircles = circles.filter((c) => c.isOpen);

	return !!openCircles.find((circl) => corners.every((corner) => isInsideCircle(corner, circl)));
}
